var exports = {
  "kL": "DMFriendsView.module__container___NU9iYj",
  "Em": "DMFriendsView.module__mainColumn___NU9iYj",
  "Qs": "DMFriendsView.module__content___NU9iYj",
  "sf": "DMFriendsView.module__searchWrapper___NU9iYj",
  "qc": "DMFriendsView.module__searchIcon___NU9iYj",
  "MJ": "DMFriendsView.module__tabBody___NU9iYj",
  "VW": "DMFriendsView.module__headerContent___NU9iYj",
  "cP": "DMFriendsView.module__titleSection___NU9iYj",
  "gr": "DMFriendsView.module__titleIcon___NU9iYj",
  "Qw": "DMFriendsView.module__titleText___NU9iYj",
  "yF": "DMFriendsView.module__divider___NU9iYj",
  "me": "DMFriendsView.module__tabsWrapper___NU9iYj",
  "xd": "DMFriendsView.module__tabsScroller___NU9iYj",
  "VD": "DMFriendsView.module__tabsInner___NU9iYj",
  "eg": "DMFriendsView.module__tabButton___NU9iYj",
  "vu": "DMFriendsView.module__active___NU9iYj",
  "zB": "DMFriendsView.module__primary___NU9iYj",
  "Lj": "DMFriendsView.module__tabContent___NU9iYj",
};

module.exports = exports;
